import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-madam',
  templateUrl: './events-madam.component.html',
  styleUrls: ['./events-madam.component.scss'],
})
export class EventsMadamComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/madam/1.jpg',
      thumbnail: 'assets/img/school/events/madam/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/2.jpg',
      thumbnail: 'assets/img/school/events/madam/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/3.jpg',
      thumbnail: 'assets/img/school/events/madam/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/4.jpg',
      thumbnail: 'assets/img/school/events/madam/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/5.jpg',
      thumbnail: 'assets/img/school/events/madam/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/6.jpg',
      thumbnail: 'assets/img/school/events/madam/6.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/7.jpg',
      thumbnail: 'assets/img/school/events/madam/7.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/8.jpg',
      thumbnail: 'assets/img/school/events/madam/8.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/9.jpg',
      thumbnail: 'assets/img/school/events/madam/9.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/10.jpg',
      thumbnail: 'assets/img/school/events/madam/10.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/11.jpg',
      thumbnail: 'assets/img/school/events/madam/11.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/madam/12.jpg',
      thumbnail: 'assets/img/school/events/madam/12.jpg',
      alt: 'Image 01',
    },
  ];
}
